import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {LoggerService} from '../../services/sp-logger/logger.service';
import {RoleUtils} from "../../utils/role/role-utils";
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';
import { Session } from 'src/app/classes/auth/session';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(private router: Router, private logger: LoggerService, protected sessionProvider: SessionProviderService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
      const checkSession = async (session: Session) => {
        if(!next.data.permission) {
          this.logger.logWarning("Data permission not defined for permission guard");
          return false;
        } else {
          let bypass = false;
          if (next.data.freemiumBypass) {
            bypass = session.user.role.level <= RoleUtils.freemiumLevel;
          }
          const granted = await session.hasPermission(next.data.permission)
          return (granted || bypass) ? true : this.router.parseUrl('/page-access-denied')
        }
      }
      return new Promise<boolean | UrlTree>(resolve => {

        if (this.sessionProvider.activeSession) {
          resolve(checkSession(this.sessionProvider.activeSession));
        } else {
          firstValueFrom(this.sessionProvider.sessionChangeListener).then(session => {
            resolve(checkSession(session));
          });
        }
      });
  }

}
